import Row from '@components/Row';
import styled from '@emotion/styled';
import { OptionGroup } from '@models/item';

import OptionItem from './OptionItem';

interface Props {
    optionGroup: OptionGroup;
    itemId: string;
}

function IconOption({ optionGroup, itemId }:Props) {
    const { options, optionGroupId, name } = optionGroup;
    return (
        <Wrapper aria-label='option-group'
            data-option-group-name={name}
            data-option-group-id={optionGroupId }>
            <Container justify='center'
                align='flex-start'
                spacing={12}
                fullWidth>
                {options.map((option) => (
                    <OptionItem option={option}
                        itemId={itemId}
                        optionGroupId={optionGroupId}
                        key={option.optionId}/>
                ))}
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    margin: 0 auto;
    width: calc(100% - 32px);
    border-top: 1px solid var(--color-gray2);
`;

const Container = styled(Row)`
    padding: 16px 0;
`;

export default IconOption;
